import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [tblwebusers, setTblwebusers] = useState([]);
const [crit, setCrit] = useState({txt:'', verified:0, xtlname:""});
const [webuser, setWebuser] = useState({WEB_USER_ID:null});
const [dowait, setDowait] = useState({on:false});
const [dlwait, setDlwait] = useState({show:false});
const [modal, setModal] = useState({open:false});
const [idtype, setIdtype] = useState([
<option key='lsta1' value=''></option>
,<option key='lsta2' value='TCI Belonger Card'>TCI Belonger Status</option>
,<option key='lsta3' value='Passport'>Passport</option>
,<option key='lsta4' value='Driver License'>Driver License</option>
,<option key='lsta5' value='NIB or NHIB Card'>NIB or NHIB Card</option>
,<option key='lsta6' value='Other Id'>Other Id</option>
]);

const location = useLocation();


useEffect(() => {

const AD_USER = sessionStorage.getItem("AD_USER")??"";

if (AD_USER==""){
	navigate("/");
	return;
	}//end if

if (tblwebusers.length<1){
	gettblwebusers();
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {
	document.getElementsByName('txt')[0].focus();
	
 },[JSON.stringify(tblwebusers)]);

useEffect(() => {
	console.log('webuser.VERIFY_DATE: '+webuser.VERIFY_DATE);//JSON.stringify(webuser)
	if (webuser.WEB_USER_ID!=null){
		if (modal.open==false)
			toggleModalsm();
			
		}//end if
		
 },[webuser]);



useEffect(() => {
		gettblwebusers();
 },[crit]);

function handleChange(e){
	
	const {name, value} = e.target;
	console.log("handleChange: "+name+", "+value);
	
	if (name=="verified")
		setCrit((prev)=>{
			return {...prev, verified:e.target.checked?1:0}
		});
	else
		setCrit((prev)=>{
			return {...prev, [name]:value}
		});
	
	
}//end if

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func

async function gettblwebusers(){

const params = {
	USERNAME:sessionStorage.getItem("USERNAME")
	, crit:crit
	, verified:crit.verified
	};
	
console.log('params: '+JSON.stringify( params));
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	setTblwebusers([]);
	
  await fetch(resturl+'rarwpform/gettblwebusers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwebusers(res) )
      .catch(err => console.log(err));

}//end func


function aftergettblwebusers(res){
if (res.length==undefined)
	return;
	
console.log('aftergettblwebusers, res.length: '+res.length);

let htmrows=[];
res.map((col, index) => {
	const WEB_USER_ID=col['WEB_USER_ID'];
	const trkey='tr_'+WEB_USER_ID;
	//const rdkey='rd_'+appid;
	
	const htmrow=<tr key={trkey} >
	<td align='left' >{col['TC_STAMP']}</td>
	<td align='left' >{col['EMAIL']}</td>
	<td align='left' ><a href="#" className="nodecor" onClick={(e)=>{getwebuser(e, WEB_USER_ID);}} ><img src="img/folderyel.png"  height='18'  border="0" />{col['FULLNAME']}</a></td>
	<td align='left' >{col['AGENCY']}</td>
	<td align='left' >{col['XTL_NAME']}</td>
	<td align='left' >{col['WPT_USERNAME']}</td>
	<td align='left' >{col['STATUS']}</td>
	<td align='left' >{col['STATUS_DATE']}</td>
	<td align='left'  >{col['STATUS_USER']}</td>
	</tr>;
	htmrows.push(htmrow);
});

setTblwebusers(htmrows);
}//end func


function getwebuser(e, WEB_USER_ID){
e.preventDefault();
console.log('resturl: '+resturl);
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WEB_USER_ID:WEB_USER_ID} )
  };		

  fetch(resturl+'rarwpform/getwebuser',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwebuser(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwebuser(res){
if (res.length==undefined)
	return;

let datas={};

for(var attributename in res[0]){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
	}//end for	
	
setWebuser(datas);

}//end func

function webuserChange(e){
//const val=e.target.value;
console.log('e.target.value: '+e.target.value)
const {name, value}=e.target;

setWebuser((prev) => {
return {...prev, [name]:value}
});	
}//end func





async function updatewebuserxtlname(e){
	
e.preventDefault();
//console.log('resturl: '+resturl);

/*
const confirmed=window.confirm("verify this user's registration?");

if (!confirmed)
	return;

*/

const params={
	USERNAME:sessionStorage.getItem("USERNAME")
	, WEB_USER_ID:webuser.WEB_USER_ID
	, XTL_NAME:webuser.XTL_NAME
	, STATUS:webuser.STATUS
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwpform/updatewebuserxtlname',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatewebuserxtlname(res) )
      .catch(err => console.log(err));	
	
}//end func


function afterupdatewebuserxtlname(res){
	
	
const XTL_NAME=res.length?(res[0].XTL_NAME??""):"";
	
if (XTL_NAME=="")	
	showsnackbar("operation failed!");
else{
	showsnackbar("done!");
	setWebuser((prev)=>{
		return {...prev, XTL_NAME:res[0].XTL_NAME}
	});
	}//end else 
	
}//end func


function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



async function refusewebuser(e){
e.preventDefault(); 

const confirmed=window.confirm("refuse this user's registration?");

if (!confirmed)
	return;

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WEB_USER_ID:webuser.WEB_USER_ID, USERNAME:sessionStorage.getItem("USERNAME")} )
  };		

  await fetch(resturl+'rarwpform/refusewebuser',requestOptions)
      .then(res => res.json())
      .then(res => 	afterrefusewebuser(res) )
      .catch(err => console.log(err));	
	
}//end func

function afterrefusewebuser(res){
	
let REFUSE_COUNT=0;
if (res.length)
	if (res.length==1)
		REFUSE_COUNT=res[0].REFUSE_COUNT;

if (REFUSE_COUNT==0)
	showsnackbar("that failed!  try again or contact admin");
else
	showsnackbar("done!");

	
}//end func
	
  return (
    <>
	
<div align='center' style={{marginTop:"10px", marginBottom:"10px"}}>
				Group:<select name='xtlname' value={crit.xtlname}  onChange={(e)=>{handleChange(e);}} >
				<option value='' ></option>
				<option value='Board' >Board</option>
				<option value='Intel' >Intel</option>
				</select>
&nbsp;&nbsp;&nbsp;
search criteria:
&nbsp;<input name='txt' value={crit.txt} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='search by name' />
&nbsp;&nbsp;<input type="checkbox" id="cbverified" name="verified" defaultValue={crit.verified} onClick={(e)=>{handleChange(e);}} />
<label htmlFor="cbverified" className="hand" >show verified & refused users</label>
</div>
	
	<table align='center' className='customers' style={{width:"85%"}} >
	<thead>
	<tr>
		<th>registr. date</th>
		<th>email address</th>
		<th>full name</th>
		<th>agency</th>
		<th>Group</th>
		<th>case worker</th>
		<th>status</th>
		<th>status date</th>
		<th>status user</th>
		
		
	</tr>
	</thead>
	<tbody>
		{tblwebusers}
	</tbody>
	</table>

<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >

			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >Photo Path: </td>
			<td align='left' ><input name='PHOTO_PATH' defaultValue={webuser.PHOTO_PATH}  onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}}  autoComplete='off' /></td>
			<td rowspan="6" >
				<img src={"https://borderforceapps.gov.tc/rarwpform/getwebuserfoto?path="+webuser.PHOTO_PATH} border="0" height="160" />
			</td>
			</tr>
			<tr>
			<td align='right' >Date: </td>
			<td align='left' ><input name='TC_STAMP' defaultValue={webuser.TC_STAMP}  onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}}  autoComplete='off'  /></td>
			</tr>
			<tr>
			<td align='right' >Full Name: </td>
			<td align='left' ><input name='FULLNAME' defaultValue={webuser.FULLNAME}  onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}}  autoComplete='off' /></td>
			</tr>
			<tr>
			<td align='right' >Email: </td>
			<td align='left' ><input name='EMAIL' defaultValue={webuser.EMAIL} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}}  /></td>
			</tr>
			<tr>
			<td align='right' >Phone: </td>
			<td align='left' ><input name='PHONE' defaultValue={webuser.PHONE} onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}}  /></td>
			</tr>
			<tr>
			<td align='right' >Agency: </td>
			<td align='left' ><input name='AGENCY' defaultValue={webuser.AGENCY}  onChange={(e)=>{webuserChange(e);}} readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}}  autoComplete='off' /></td>
			</tr>
			<tr>
			<td align='right' >Satus: </td>
			<td align='left' >
				<select name='STATUS' value={webuser.STATUS}  onChange={(e)=>{webuserChange(e);}} >
				<option value='' ></option>
				<option value='VERIFIED' >VERIFIED</option>
				<option value='REFUSED' >REFUSED</option>
				</select>
				&nbsp;<input defaultValue={webuser.STATUS_DATE}  readOnly className="gnsbro"  onFocus={(e)=>{e.target.select();}} />
			</td>
			</tr>

			<tr>
			<td align='right' >Group: </td>
			<td align='left' >
				<select name='XTL_NAME' value={webuser.XTL_NAME} onChange={(e)=>{webuserChange(e);}} >
				<option value='' ></option>
				<option value='Board' >Board</option>
				<option value='Intel' >Intel</option>
				</select>
				
			</td>
			</tr>

			<tr>
			<td align='right' >&nbsp;</td>
			<td align='left' >
			{dowait.on && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{!dowait.on && <button className="button" id='btnupdate' onClick={(e)=>{updatewebuserxtlname(e);}} >save changes</button>}
			</td>
			</tr>		
			</tbody>
			</table>
		
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;